import React, { useEffect, useState } from "react";
import moment from "moment";
// primeReact
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
// context
import { useContextSimulator } from "../../SimulatorContext";
import { formatCurrency } from "../../../../../../utils/formatCurrency";
import NumberInput from "../../../../../../components/input/NumberInput";
import { addMonths, format, parseISO } from "date-fns";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const PlotsInstallments = () => {
  const {
    intermediateValue,
    setIntermediateValue,
    setIntermediateRange,
    minIntermediateValue,
    simulatorData,
    intermediateRange,
    firstIntermediateParcelDate,
    setFirstIntermediateParcelDate,
    selectedIntermediateTerm,
    setSelectedIntermediateTerm,
    intermediateTerms,
    intermediateParcelValue,
    intermediateParcelsTable,
    setIntermediateParcelsTable,
    financingParcelCalc,
    setFinancingParcelCalc,
    intermediateFinalValue,
    setIntermediateFinalValue,
    date,
    intermediateTotalValue,
    setIntermediateTotalValue,
    intermediateMonthsPeriod,
    setIntermediateMonthsPeriod,
    setIntermediateInterest
  } = useContextSimulator();


  useEffect(() => {
    if (minIntermediateValue && intermediateMonthsPeriod && selectedIntermediateTerm && firstIntermediateParcelDate && intermediateValue) {
      handleIntermediateCalc(firstIntermediateParcelDate, intermediateValue);
    } else {
      setIntermediateParcelsTable(null)
    }
  }, [intermediateValue, minIntermediateValue, intermediateMonthsPeriod, selectedIntermediateTerm]);

  useEffect(() => {
//    console.log("Total Inter Value: ", intermediateTotalValue);
  }, [intermediateTotalValue])

  // useEffect(() => {
//  //   console.log("Calc Qtd Inter:", selectedIntermediateTerm * parseFloat(intermediateValue));
//  //   console.log("Min Inter:", minIntermediateValue);
//  //   console.log("Min Inter:", minIntermediateValue);
//  //   console.log("Min Inter:", minIntermediateValue);

  //   if (selectedIntermediateTerm * parseFloat(intermediateValue) > parseFloat(minIntermediateValue)) {
  //     setIntermediateValue(parseFloat(minIntermediateValue) / selectedIntermediateTerm);
  //     setIntermediateRange((parseFloat(minIntermediateValue) / selectedIntermediateTerm) * 100);
  //     return;
  //   }
  // }, [selectedIntermediateTerm])

  function calculateFutureValueIntermediate(qtdInter, intervalInter, taxInter, valInter) {
    try {
//      console.log("qtdInter: ", qtdInter);
//      console.log("intervalInter: ", intervalInter);
//      console.log("taxInter: ", taxInter);
//      console.log("valInter: ", valInter);

      var taxa_anual = (1 + (taxInter / 100)) ** intervalInter - 1;
      var remanescente_inter = valInter / qtdInter;
      var dados = [];

//      console.log("taxa_anual: ", taxa_anual);
//      console.log("remanescente_inter: ", remanescente_inter);
      var total = 0;
      var totalInterest = 0;

      for (let i = 1; i <= qtdInter; i++) {
        let calc = (remanescente_inter * (1 + taxa_anual) ** i);
        dados.push(calc.toFixed(2));
//        console.log("Dados inter: ", calc.toFixed(2));
        total += parseFloat(calc);
        totalInterest += calc - remanescente_inter;
      }

      return { table: dados, total: total, totalInterest: totalInterest.toFixed(2) };
    } catch (error) {
      return error;
    }
  }

  function calculateFutureValueIntermediateOpen(qtdInter, intervalInter, taxInter, valInter) {
    try {
//      console.log("qtdInter: ", qtdInter);
//      console.log("intervalInter: ", intervalInter);
//      console.log("taxInter: ", taxInter);
//      console.log("valInter: ", valInter);

      var taxa_anual = (1 + (taxInter / 100)) ** intervalInter - 1;
//      console.log("taxa_anual: ", taxa_anual.toFixed(2));

      var valuePresenteTotal = 0;
      var valueParcelas = [];
      var totalInterest = 0;

      for (let i = 1; i <= qtdInter; i++) {
        var valuePresenteParcela = valInter / Math.pow(1 + taxa_anual, i * intervalInter / 12);
        valuePresenteTotal += valuePresenteParcela;
        valueParcelas.push(valInter);
//        console.log("VP: ", valuePresenteParcela);
//        console.log("VParcela: ", valueParcelas);

        totalInterest += valInter - valuePresenteParcela;
      }

      return { vpTotal: valuePresenteTotal, vParcel: valueParcelas, totalInterest: totalInterest.toFixed(2) };
    } catch (error) {
      return error;
    }
  }

  function calcularDatasParcelas(firstIntermediateParcelDate, intervalInter, qtdInter) {
    try {
      const datasParcelas = [moment(firstIntermediateParcelDate).format("DD/MM/YYYY")]; // Inicializa o array com a data da primeira parcela

      let currentDate = new Date(firstIntermediateParcelDate); // Converte a string para objeto Date
      let monthToAdd = intervalInter; // Define o intervalo entre as parcelas em meses

      // Loop para adicionar as datas das parcelas
      for (let i = 1; i < qtdInter; i++) {
        // Adiciona o intervalo de meses à data atual
        currentDate.setMonth(currentDate.getMonth() + monthToAdd);

        // Adiciona uma cópia da data atual ao array de datas das parcelas
        datasParcelas.push(moment(currentDate).format("DD/MM/YYYY"));
      }

      return datasParcelas; // Retorna o array com as datas das parcelas
    } catch (error) {
      return error;
    }
  }

  function criarObjetoParcelas(parcels, datasParcelas) {
    const objetoParcelas = [];

    for (let i = 0; i < parcels.length; i++) {
      const parcela = {
        sequence_number: `${i + 1}/${parcels.length}`,
        value: formatCurrency(parcels[i]),
        due_date: datasParcelas[i],
        want_choose: 0
      };
      objetoParcelas.push(parcela);
    }

    return objetoParcelas;
  }

  const handleIntermediateCalc = async (date, interValue) => {
    if (simulatorData.intermediate_open && (selectedIntermediateTerm * parseFloat(intermediateValue) > parseFloat(minIntermediateValue))) {
      setIntermediateValue(parseFloat(minIntermediateValue) / selectedIntermediateTerm);
      setIntermediateRange((parseFloat(minIntermediateValue) / selectedIntermediateTerm) * 100);
      return;
    }

    let parcels;
//    console.log("Val interValue: ", interValue);
//    console.log("Val minIntermediateValue: ", minIntermediateValue);

    const valInter = interValue ? interValue : minIntermediateValue;
//    console.log("Val Inter: ", valInter);
    const intervalInter = intermediateMonthsPeriod;
    const qtdInter = selectedIntermediateTerm;
    const taxInter = simulatorData.intermediate_rate;

    if (simulatorData.intermediate_open) {
      const parcelasOpen = calculateFutureValueIntermediateOpen(qtdInter, intervalInter, taxInter, valInter);
      parcels = parcelasOpen.vParcel;
//      console.log("Intermediaria parcelasOpen: ", parcelasOpen);
      setIntermediateInterest(parseFloat(parcelasOpen.totalInterest));
      setIntermediateTotalValue((qtdInter * parseFloat(valInter)).toFixed(2));
      setIntermediateFinalValue(parcelasOpen.vpTotal.toFixed(2));
    } else {
      const parcelas = await calculateFutureValueIntermediate(qtdInter, intervalInter, taxInter, valInter);
      parcels = parcelas.table;
//      console.log("Intermediaria parcelas: ", parcelas);
      setIntermediateInterest(parseFloat(parcelas.totalInterest));
      setIntermediateTotalValue(parcelas.total.toFixed(2));
      setIntermediateFinalValue(minIntermediateValue);
    }

    const datasParcelas = await calcularDatasParcelas(date, intervalInter, qtdInter);
    const objetoParcelas = criarObjetoParcelas(parcels, datasParcelas);
    setIntermediateParcelsTable(objetoParcelas)
  }

  return (
    <>
      <div className="row">
        {simulatorData.intermediate_open && (
          <div className="col-xl-3 col-md-6 pb-2">
            <label htmlFor="entrada">Valor da Parcela</label>
            <InputNumber
              inputId="entrada"
              value={intermediateValue}
              onValueChange={(e) => {
                setIntermediateValue(e.value);
                setIntermediateRange(e.value * 100);
              }}
              mode="currency"
              currency="BRL"
              locale="pt-BR"
              useGrouping={true}
              min={0}
              max={minIntermediateValue}
              className="input"
            />
            <input
              type="range"
              className="w-100"
              value={intermediateRange}
              onChange={(e) => {
                setIntermediateValue(e.target.value / 100);
                setIntermediateRange(e.target.value);
              }}
              min={0}
              max={minIntermediateValue * 100}
              step={1000}
            />
          </div>
        )}

        <div className="col-xl-3 col-md-6 pb-2">
          <label className="mb-3">Quantidade de Parcelas</label>
          <InputNumber value={selectedIntermediateTerm} onValueChange={(e) => setSelectedIntermediateTerm(e.value)} showButtons buttonLayout="horizontal" step={1}
            max={simulatorData.intermediate_max_installments ? simulatorData.intermediate_max_installments : 0} min={0}
            decrementButtonClassName="p-button-danger" incrementButtonClassName="p-button-success" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" />
        </div>

        <div className="col-xl-3 col-md-6 pb-2">
          <label className="mb-3">Informe o Período (Mês)</label>
          <InputNumber value={intermediateMonthsPeriod}
            onValueChange={(e) => { setIntermediateMonthsPeriod(e.value) }}
            showButtons buttonLayout="horizontal" step={3}
            max={180}
            decrementButtonClassName="p-button-danger" incrementButtonClassName="p-button-success" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" />
        </div>

        <div className="col-xl-3 col-md-6 pb-2">
          <label className="mb-3">Data Parcelas</label>
          <Calendar
            value={firstIntermediateParcelDate}
            onChange={(e) => {
              setFirstIntermediateParcelDate(e.value)
              handleIntermediateCalc(e.value, intermediateValue)
            }}
            dateFormat={"dd/mm/yy"}
              mask="99/99/9999"
            className="w-100"
            locale="pt"
            // minDate={new Date()}
          />
        </div>
      </div>
      {intermediateParcelsTable && (
        <div className="row pt-4">
          <DataTable value={intermediateParcelsTable} size={"normal"}
            paginator
            rows={5}
            rowsPerPageOptions={[5, 10, 25]}>
            <Column field="sequence_number" header="Parcela"></Column>
            <Column field="value" header="Valor"></Column>
            <Column field="due_date" header="Data Pagamento"></Column>
            {/* <Column field="interest" header="Juros"></Column> */}
          </DataTable>
        </div>
      )}
    </>
  );
};

export default PlotsInstallments;
